import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import PortalLayout from "@/components/layout/PortalLayout";
import Home from "@/pages/home/page";
import PostDetail from "@/pages/post/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <PortalLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "post/:id", element: <PostDetail /> },
      { path: "about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;